(() => {
    class Overlay extends App.Component {
        constructor(container) {
            super(container);
            this.CONTAINER_TITLE_SELECTOR   = 'overlay-title-container';    // Here we render the title
            this.CONTAINER_CONTENT_SELECTOR = 'overlay-content-container';  // Here we render the content
            this.CONTAINER_BUTTONS_SELECTOR = 'overlay-button-container';   // Here we render the buttons
        }

        async setPage(Page) {
            await App.Layout.setFMPResources(Page);

            // Render
            this.brand      = Page.brand;
            this.title      = Page.title;
            this.content    = Page.content;
            this.buttons    = Page.buttons;

            await App.Layout.setFCPResources(Page);
            App.Layout.refresh();
        }

        set title(title) {
            const container = this.querySelector(this.CONTAINER_TITLE_SELECTOR);
            if (container) container.innerHTML = title;
        }

        set content(content) {
            const container = this.querySelector(this.CONTAINER_CONTENT_SELECTOR) || this.container;
            container.innerHTML = content;
        }

        set buttons(buttons) {
            const container = this.querySelector(this.CONTAINER_BUTTONS_SELECTOR);
            if (container) container.innerHTML = buttons.join(' ');
        }

        set brand(brand) {
            this.container.dataset.brand = brand;
        }

        querySelector(selector) {
            return this.container.querySelector('.js-' + selector);
        }

        empty() {
            // Render
            this.brand      = '';
            this.title      = '';
            this.content    = '';
            this.buttons    = [];
        }
    }
    App.Components.register(App.Components.selector('overlay'), Overlay, 'Overlay');
})();
